import { Box, Card, CardContent, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

interface FeaturesProps {
    featuresText?: string 
}

const Features = ({featuresText}:FeaturesProps) => {
  return (
    <Card
      elevation={0}
      variant="outlined"

      sx={{
        position: "relative",
        borderRadius: "12px",
        width: "100%",
        //boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.1)",
        backgroundColor: "rgba(256, 256, 256, 0.7)",
        backdropFilter: "blur(5px)",
      }}
    >
      <CardContent
        sx={{
          padding: {
            xs: "8px", // Mobile
            sm: "16px", // Tablet
            md: "16px", // Desktop
          },
          "&:last-child": {
            paddingBottom: "16px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flex: 1,
              alignItems: "center",
            }}
          >
            <Box>
              <Typography
                gutterBottom
                variant="body1"
                sx={{
                  fontWeight: "500",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1, // Number of lines before truncation
                  textOverflow: "ellipsis",
                  height: "24px",
                  overflow: "hidden",
                  width: "250px",
                  wordBreak: "break-word",
                  mb: "0",
                }}
              >
                {featuresText}
              </Typography>
            </Box>
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                //display: hovered ? "flex" : "none",
                gap: 1,
              }}
            >
              <IconButton
                aria-label="edit"
                size="small"
                //onClick={() => props.editFun(props.data)}
              >
                <EditIcon fontSize="inherit" />
              </IconButton>

              <IconButton
                aria-label="delete"
                size="small"
                //onClick={() => props.deleteFun(props.data)}
              >
                <DeleteIcon fontSize="inherit" />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Features;
